import type { ColorList } from '@/app/[locale]/[year]/blocks/layoutStyles'

type Palette = {
  bg: string
  headline: string
  text: string
}

export const palettes: {
  readonly [key in ColorList | string | '#F3F3F2']?: Palette
} = {
  // gray
  '#F3F3F2': {
    bg: 'group-odd/section:bg-white group-odd/section:[&_a]:border-gray-dimmed group-even/section:bg-gray-dimmed group-even/section:[&_a]:border-white',
    headline: 'text-red',
    text: 'text-offBlack',
  },

  // blue
  '#266782': {
    bg: 'group-odd/section:bg-teal-800 group-even/section:bg-teal-900',
    headline: 'text-yellow',
    text: 'text-white',
  },

  // yellow
  '#FFF166': {
    bg: 'group-odd/section:bg-yellow group-even/section:bg-yellow-light',
    headline: 'text-red',
    text: 'text-offBlack',
  },
} as const

export const primaryPalettes: {
  readonly [key in ColorList | string | '#F3F3F2']?: Palette
} = {
  // gray
  '#F3F3F2': {
    bg: 'bg-white [&_a]:border-gray-dimmed',
    headline: 'text-red',
    text: 'text-offBlack',
  },

  // blue
  '#266782': {
    bg: 'bg-teal-900',
    headline: 'text-yellow',
    text: 'text-white',
  },

  // yellow
  '#FFF166': {
    bg: 'bg-yellow',
    headline: 'text-red',
    text: 'text-offBlack',
  },
} as const
const defaultTheme = '#F3F3F2' as const

export function getTheme(theme?: string | null): Palette {
  if (!theme) return palettes[defaultTheme]!

  return palettes[theme] || palettes[defaultTheme]!
}

export function getPrimaryTheme(theme?: string | null): Palette {
  if (!theme) return primaryPalettes[defaultTheme]!

  return primaryPalettes[theme] || primaryPalettes[defaultTheme]!
}
